import { FilterSegmentSelect } from "./FilterSegmentSelect";
import { SaveFilterSegmentButton } from "./SaveFilterSegmentButton";

export const DataTableSegment = {
  SaveButton: SaveFilterSegmentButton,
  Select: FilterSegmentSelect,
};
